/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Tr_LeadInputs */

const en_mk_tut_tr_lead = /** @type {(inputs: Mk_Tut_Tr_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The twelve things people ask most often, including about the virtual office and meetings.`)
};

const id_mk_tut_tr_lead = /** @type {(inputs: Mk_Tut_Tr_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dua belas hal yang paling sering ditanyakan, termasuk soal kantor virtual dan rapat.`)
};

/**
* | output |
* | --- |
* | "The twelve things people ask most often, including about the virtual office and meetings." |
*
* @param {Mk_Tut_Tr_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_tr_lead = /** @type {((inputs?: Mk_Tut_Tr_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Tr_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_tr_lead(inputs)
	return en_mk_tut_tr_lead(inputs)
});